/*
 * @Author: cn1994
 * @Date: 2023-09-20 15:47:48
 * @LastEditors: cn1994
 * @LastEditTime: 2023-10-17 18:23:35
 * @Description: file content
 */
import request from '@/common/request.js'
import qs from 'qs'

// 免登陆接口
export const checkLogin = (params) => {
  return request({
    url: `OSS/index.php?g=Login&m=Index&a=checkLogin`,
    method: 'get',
    params
  })
}

// 通过token,serverid,domain进行登陆
export const loginByParams = (data) => {
  return request({
    url: `BUSINESS/login/doTokenLogin`,
    method: 'post',
    data: qs.stringify(data)
  })
}

// 老ugc跳转新后台登陆验证接口
export const loginUgcLoginToBook = (data) => {
  return request({
    url: `BUSINESS/login/ugcLoginToBook`,
    method: 'post',
    data: qs.stringify(data)
  })
}

export default {
  checkLogin,
  loginByParams,
  loginUgcLoginToBook
}